module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8zEmg"))).then(() => parcelRequire('7GUXC'));